import { showToastMessage } from "../toast_message.js";
import { logFrontendError } from "../log_error.js";

export function likeSketch(event){
    const likeButton = event.target.closest('.like-button');
    const likeOrUnlike = likeButton.classList.contains("liked") ? "unlike" : "like";
    const sketchId = likeButton.dataset.sketchId;
    const url = `/api/sketch/${sketchId}/like`;
    const method = likeOrUnlike === "like" ? "POST" : "DELETE";

    likeButton.disabled = true;
    return fetch(url, {
        method: method
    })
        .then(response => {
            if(!response.ok){
                throw new Error(`Error during ${likeOrUnlike}`);
            }
            return response.json();
        })
        .then(data => {
            if(!data.success){
                throw new Error(data.error);
            }
            setLikedState(likeButton, data.liked);
            return data.liked;
        })
        .catch((err) => {
            showToastMessage(err, "danger");
            logFrontendError(err);
            return undefined;
        })
        .finally(() => {
            likeButton.disabled = false;
        });
}

export function showWhetherLiked(btn, likedSketches){
    setLikedState(btn, likedSketches.has(btn.dataset.sketchId));
}

function setLikedState(btn, liked){
    btn.classList.toggle("liked", liked);
    btn.dataset.liked = liked;
    btn.setAttribute("aria-pressed", liked);
    btn.setAttribute("aria-label", liked ? "Remove bookmark" : "Bookmark");
    btn.title = liked ? "Bookmarked" : "Bookmark";
    const icon = btn.querySelector("i");
    if (icon) {
        icon.classList.toggle("bi-bookmark-heart-fill", liked);
        icon.classList.toggle("bi-bookmark-heart", !liked);
    }
}
